import React from 'react';

interface UserManagementIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const UserManagementIcon: React.FC<UserManagementIconProps> = ({
  width = 28,
  height = 28,
  color = '#fff',
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_573_585)">
        <path
          d="M11.155 19.5426L11.6782 19.2601C11.8915 19.145 11.9646 18.8899 11.8415 18.6904L10.85 17.0845C10.7674 16.9507 10.6175 16.8759 10.4634 16.8759C10.3877 16.8759 10.311 16.8939 10.2408 16.9319L9.71753 17.2144C9.64565 17.2531 9.56944 17.2708 9.49521 17.2708C9.26224 17.2708 9.04859 17.0967 9.04859 16.8532V16.2882C9.04859 16.0579 8.84894 15.8711 8.60258 15.8711H6.61951C6.37323 15.8711 6.1735 16.0578 6.1735 16.2882V16.8532C6.1735 17.0967 5.95978 17.2708 5.72689 17.2708C5.65265 17.2708 5.57644 17.2531 5.50457 17.2144L4.98128 16.9319C4.91108 16.8939 4.83434 16.876 4.75874 16.8759C4.60457 16.8759 4.45473 16.9507 4.37213 17.0845L3.38063 18.6904C3.25749 18.8899 3.33058 19.145 3.54385 19.2601L4.06714 19.5426C4.36445 19.7032 4.36445 20.1045 4.06714 20.265L3.54385 20.5475C3.33051 20.6627 3.25749 20.9177 3.38063 21.1172L4.37213 22.7232C4.45473 22.8569 4.60464 22.9318 4.75874 22.9318C4.83441 22.9318 4.91108 22.9137 4.98128 22.8758L5.50457 22.5933C5.57644 22.5545 5.65265 22.5368 5.72689 22.5368C5.95985 22.5368 6.1735 22.711 6.1735 22.9545V23.5195C6.1735 23.7498 6.37316 23.9366 6.61951 23.9366H8.60251C8.84879 23.9366 9.04852 23.7498 9.04852 23.5195V22.9545C9.04852 22.711 9.26224 22.5368 9.49513 22.5368C9.56937 22.5368 9.64558 22.5545 9.71745 22.5933L10.2407 22.8758C10.3109 22.9137 10.3877 22.9318 10.4633 22.9318C10.6175 22.9318 10.7673 22.8569 10.8499 22.7232L11.8414 21.1172C11.9645 20.9177 11.8914 20.6627 11.6782 20.5475L11.1549 20.265C10.8576 20.1045 10.8576 19.7031 11.155 19.5426ZM7.61109 21.1411C6.88032 21.1411 6.28797 20.5871 6.28797 19.9038C6.28797 19.2205 6.88039 18.6665 7.61109 18.6665C8.34178 18.6665 8.9342 19.2205 8.9342 19.9038C8.9342 20.5871 8.34178 21.1411 7.61109 21.1411Z"
          fill={color}
        />
        <path
          d="M10.8109 8.06224C10.5716 7.83863 10.184 7.83863 9.94468 8.06224C9.70547 8.286 9.70547 8.6486 9.94468 8.87229L11.0392 9.89571C7.0165 10.082 3.76028 13.0367 3.4079 16.7597L3.49841 16.6131C3.75746 16.1934 4.24044 15.9327 4.7587 15.9328C4.76965 15.9328 4.78053 15.9337 4.79148 15.934C5.48164 13.2511 7.98328 11.2219 11.0142 11.0457L9.94468 12.0458C9.70547 12.2694 9.70547 12.6321 9.94468 12.8558C10.0643 12.9676 10.221 13.0235 10.3778 13.0235C10.5345 13.0235 10.6913 12.9676 10.8108 12.8558L12.9408 10.864C13.0556 10.7565 13.1201 10.6109 13.1201 10.459C13.1201 10.3071 13.0556 10.1614 12.9408 10.054L10.8109 8.06224Z"
          fill={color}
        />
        <path
          d="M18.5506 10.9919C19.9106 10.9919 21.017 9.95722 21.017 8.68543C21.017 7.41356 19.9106 6.37891 18.5506 6.37891C17.1906 6.37891 16.0842 7.41356 16.0842 8.68536C16.0842 9.95715 17.1906 10.9919 18.5506 10.9919Z"
          fill={color}
        />
        <path
          d="M23.3553 17.2098V14.039C23.3553 13.1614 22.7522 12.383 21.8602 12.1098L21.8561 12.1086L20.5516 11.9066C20.4405 11.8746 20.3219 11.9296 20.2819 12.032L18.8017 15.83C18.7163 16.0492 18.3849 16.0492 18.2995 15.83L16.8193 12.032C16.787 11.9493 16.7035 11.8975 16.6141 11.8975C16.5929 11.8975 15.2451 12.1083 15.2451 12.1083C14.3459 12.3885 13.745 13.168 13.745 14.0496V17.2098C13.745 17.6834 14.1556 18.0673 14.662 18.0673H22.4383C22.9448 18.0673 23.3553 17.6834 23.3553 17.2098Z"
          fill={color}
        />
        <path
          d="M24.4453 17.9688C24.3941 18.6242 23.8191 19.0255 23.1181 19.073C22.581 21.9483 19.984 24.1685 16.8068 24.3532L17.8763 23.3531C18.1155 23.1293 18.1155 22.7667 17.8763 22.543C17.637 22.3194 17.2494 22.3194 17.0101 22.543L14.8802 24.5348C14.641 24.7586 14.641 25.1212 14.8802 25.3449L17.0101 27.3366C17.1297 27.4484 17.2864 27.5043 17.4432 27.5043C17.5999 27.5043 17.7567 27.4484 17.8762 27.3366C18.1154 27.1129 18.1154 26.7502 17.8762 26.5265L16.7818 25.5031C21.0432 25.3058 24.4453 22.0018 24.4453 17.9688Z"
          fill={color}
        />
        <path
          d="M19.0882 11.8634C19.0314 11.8055 18.9482 11.7764 18.8641 11.7764H18.237C18.153 11.7764 18.0698 11.8055 18.0129 11.8634C17.9249 11.9531 17.9122 12.0826 17.9746 12.1838L18.3098 12.6564L18.1529 13.8943L18.4619 14.6631C18.492 14.7404 18.6089 14.7404 18.6391 14.6631L18.9482 13.8943L18.7912 12.6564L19.1264 12.1838C19.189 12.0826 19.1762 11.9531 19.0882 11.8634Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_573_585">
          <rect
            width="27"
            height="27"
            fill="white"
            transform="translate(0.445312 0.503906)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserManagementIcon;
